export default __webpack_public_path__ + "577347e444e934c94f951ff044ce488e.png";